module.exports = __webpack_public_path__ + "img/refresh-white.269636e8.svg";